import moment from 'moment';

import { customCompareDates, getDateFormat } from './dateUtils';
import {
  FORM_HISTORY_STATUSES,
  FORM_STATUS_INWORKS,
} from '../form-designer/constants/editor.constants';

export const formatRows = (rows) =>
  rows.map((row) => {
    const { OPS_PUBLISHED } = row;
    return {
      ...row,
      STATUS: FORM_HISTORY_STATUSES[OPS_PUBLISHED] ?? '',
    };
  });

export const createCustomDateFilter = (accessor) => (row, filters) => {
  const filterDate =
    filters[accessor] && moment(filters[accessor], getDateFormat(filters[accessor])).valueOf();

  if (!filterDate) {
    return true;
  }

  const rowDate =
    row[accessor] &&
    moment(row[accessor])
      .startOf('day')
      ?.valueOf();

  // compare in milliseconds
  return rowDate === filterDate;
};

export const getCompareFileName = ({ baselineVersion, compareToVersion }) => {
  const { OPS_VERSION: version1, OPS_RELEASE_TYPE: releaseType1 } = baselineVersion;
  const { OPS_VERSION: version2, OPS_RELEASE_TYPE: releaseType2 } = compareToVersion;

  return `${releaseType1}_v${version1}-${releaseType2}_v${version2}`;
};

export const createCustomCompareDatesForTable = (accessor, sortOrder) => (rowA, rowB) => {
  const valueA = rowA[accessor];
  const valueB = rowB[accessor];

  return customCompareDates(valueA, valueB, sortOrder);
};

export const getCompareDetails = (selectedRows, rows) => {
  const [firstRowDetail, secondRowDetail] = selectedRows.map((id) =>
    rows.find((row) => row.OPS_ID === id)
  );

  if (firstRowDetail.OPS_PUBLISHED === FORM_STATUS_INWORKS) {
    return { baselineVersion: secondRowDetail, compareToVersion: firstRowDetail };
  } else if (secondRowDetail.OPS_PUBLISHED === FORM_STATUS_INWORKS) {
    return { baselineVersion: firstRowDetail, compareToVersion: secondRowDetail };
  } else {
    return new Date(firstRowDetail.OPS_PUBLISHED_DATE).getTime() >
      new Date(secondRowDetail.OPS_PUBLISHED_DATE).getTime()
      ? { baselineVersion: secondRowDetail, compareToVersion: firstRowDetail }
      : { baselineVersion: firstRowDetail, compareToVersion: secondRowDetail };
  }
};
